<div class="custom-margin">
    <section class="section-card">
        <div fxLayout="row">
            <div fxFlex="50%">
                <h2 class="page_heading">Guest User Register</h2>
            </div>
        </div>

        <article class="inner-box-header">
            <ul class="quotations-steps">
                <li class="active">
                    <span> 1 </span>
                    <p>Company Details</p>
                </li>
                <li>
                    <span> 2 </span>
                    <p>Configuration</p>
                </li>
            </ul>
        </article>

        <div class="row mt-5">
            <form name="companyDetailsForm" (ngSubmit)="companyDetailsForm.valid  && submit()"
                #companyDetailsForm="ngForm" novalidate>
                <div fxLayout="row">
                    <div fxFlex="100%">
                        <fieldset [disabled]="readable">
                            <div class="row mt-4">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="company_name" class="form-label  mandatory">Company Name</label>
                                        <input type="text" class="form-control" name="company_name" id="company_name"
                                            [(ngModel)]="guestuser.company_name" #company_name="ngModel" required
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && company_name.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && company_name.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="company_name.errors['required']">Company Name Address is
                                                required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="cin_no" class="form-label">CIN NO.</label>
                                        <input type="text" class="form-control" name="cin_no" id="cin_no"
                                            [(ngModel)]="guestuser.cin_no" #cin_no="ngModel"
                                            pattern="^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$"
                                            [ngClass]="{ 'is-invalid': (cin_no.touched || companyDetailsForm.submitted) && cin_no.invalid }">
                                        <div *ngIf="(cin_no.touched || companyDetailsForm.submitted) && cin_no.invalid"
                                            class="invalid-feedback">
                                            <!-- <div *ngIf="cin_no.errors?.['required']">CIN Number is required</div> -->
                                            <div *ngIf="cin_no.errors?.['pattern']">CIN number should match the pattern:
                                                L/U + 5
                                                digits + 2 alphabetic characters + 4 digits + 3 alphabetic characters +
                                                6
                                                digits.</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="gst_no" class="form-label">GST NO</label>
                                        <input type="text" class="form-control" name="gst_no" id="gst_no"
                                            [(ngModel)]="guestuser.gst_no" #gst_no="ngModel"
                                            pattern="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
                                            [ngClass]="{ 'is-invalid': (gst_no.touched || companyDetailsForm.submitted) && gst_no.errors }">
                                        <div *ngIf="(gst_no.touched || companyDetailsForm.submitted) && gst_no.invalid"
                                            class="invalid-feedback">
                                            <!-- <div *ngIf="gst_no.errors?.['required']">GST Number is required</div> -->
                                            <div *ngIf="gst_no.errors?.['pattern']">GST number should match the pattern:
                                                99AAAAA9999A1Z1.</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="contact_person_Name" class="form-label  mandatory">Contact Person
                                            Name</label>
                                        <input type="text" class="form-control" name="contact_person_Name"
                                            id="contact_person_Name" [(ngModel)]="guestuser.contact_person_name"
                                            #contact_person_Name="ngModel" required
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && contact_person_Name.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && contact_person_Name.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="contact_person_Name.errors['required']">Contact Person is
                                                required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="contact_no" class="form-label  mandatory">Contact No.</label>
                                        <input type="number" class="form-control" name="contact_no" id="contact_no"
                                            [(ngModel)]="guestuser.contact_no" #contact_no="ngModel" required
                                            pattern="^[0-9]{10}$"
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && contact_no.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && contact_no.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="contact_no.errors['required']">Contact Number is required</div>
                                            <div *ngIf="contact_no.errors['pattern']">Contact Number must be valid</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="alt_contact_no" class="form-label  mandatory">Alt Contact
                                            No.</label>
                                        <input type="number" class="form-control" name="alt_contact_no"
                                            id="alt_contact_no" [(ngModel)]="guestuser.alt_contact_no"
                                            #alt_contact_no="ngModel" required pattern="^[0-9]{10}$"
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && alt_contact_no.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && alt_contact_no.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="alt_contact_no.errors['required']">Alt Contact Number is
                                                required</div>
                                            <div *ngIf="alt_contact_no.errors['pattern']">Alt Contact Number must be
                                                valid</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="email" class="form-label  mandatory">Email ID.</label>
                                        <input type="text" class="form-control" name="email" id="email"
                                            [(ngModel)]="guestuser.email" #email="ngModel" required
                                            pattern="^(?!\.)(?!.*\.$)(?!.*?\.\.)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~\-.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && email.errors }">
                                        <div *ngIf="companyDetailsForm.submitted  && email.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="email.errors['required']">Email Address is required</div>
                                            <div *ngIf="email.errors['pattern']">Email must be a valid email address
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="alt_email" class="form-label  mandatory">Alt Email ID.</label>
                                        <input type="text" class="form-control" name="alt_email" id="alt_email"
                                            [(ngModel)]="guestuser.alt_email" #alt_email="ngModel"
                                            pattern="^(?!\.)(?!.*\.$)(?!.*?\.\.)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~\-.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && alt_email.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && alt_email.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="alt_email.errors['pattern']">Email must be a valid email address
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="startDate" class="form-label mandatory">Country</label>
                                        <select class="form-select" name="country" #country="ngModel"
                                            [(ngModel)]="guestuser.country_id" required
                                            (ngModelChange)="countrySelect($event)"
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && country.invalid }">
                                            <option [ngValue]="null" [selected]="true" disabled>Select Country</option>
                                            <option *ngFor="let countryItem of countryData"
                                                [value]="countryItem.country_id">{{
                                                countryItem.country_name }}</option>
                                        </select>
                                        <div *ngIf="companyDetailsForm.submitted && country.invalid"
                                            class="invalid-feedback">
                                            <div *ngIf="country.errors?.['required']">Country is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="startDate" class="form-label mandatory">State</label>
                                        <select class="form-select" name="state" #state="ngModel"
                                            [(ngModel)]="guestuser.state_id" required
                                            (ngModelChange)="stateSelect($event)"
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && state.invalid }">
                                            <option [ngValue]="null" [selected]="true" disabled>Select State</option>
                                            <option *ngFor="let stateItem of stateData" [value]="stateItem.state_id">{{
                                                stateItem.state_name }}</option>
                                        </select>
                                        <div *ngIf="companyDetailsForm.submitted && state.invalid"
                                            class="invalid-feedback">
                                            <div *ngIf="state.errors?.['required']">State is required</div>
                                        </div>
                                        <div class="text-danger" style="font-size: 14px;"
                                            *ngIf=" state.touched && stateData.length == 0">Select country first</div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="startDate" class="form-label mandatory">City</label>
                                        <select class="form-select" name="city" #city="ngModel"
                                            [(ngModel)]="guestuser.city_id" required
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && city.invalid }">
                                            <option [ngValue]="null" [selected]="true" disabled>Select City</option>
                                            <option *ngFor="let cityItem of cityData" [value]="cityItem.city_id">{{
                                                cityItem.city_name
                                                }}</option>
                                        </select>
                                        <div *ngIf="companyDetailsForm.submitted && city.invalid"
                                            class="invalid-feedback">
                                            <div *ngIf="city.errors?.['required']">City is required</div>
                                        </div>
                                        <div class="text-danger" style="font-size: 14px;"
                                            *ngIf=" city.touched && cityData.length == 0">Select state first</div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="pin_code" class="form-label  mandatory">Pin Code</label>
                                        <input type="number" class="form-control" name="pin_code" id="pin_code"
                                            [(ngModel)]="guestuser.pin_code" #pin_code="ngModel" required
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && pin_code.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && pin_code.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="pin_code.errors['required']">Pin Code is required</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Half for uploading the logo -->
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="logoFile" class="form-label mandatory">Logo</label>
                                        <input type="file" class="form-control" name="logoFile" id="logoFile"
                                            [(ngModel)]="guestuser.logo" #logoFile="ngModel"
                                            (change)="onFileSelected($event)"
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && logoFile.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && logoFile.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="logoFile.errors['required']">Logo is required</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Half for downloading the logo -->
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="form-label">Download Logo</label>
                                        <a (click)="downloadFile()" download="logo.png" *ngIf="logoToUpload"
                                            class="btn btn-primary form-control">Download</a>
                                        <p *ngIf="!logoToUpload">No logo uploaded yet.</p>
                                    </div>
                                </div>


                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="exampleFormControlTextarea1"
                                            class="form-label  mandatory">Address</label>
                                        <input type="text" class="form-control" name="address_one" id="address_one"
                                            [(ngModel)]="guestuser.address" #address_one="ngModel" required
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && address_one.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && address_one.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="address_one.errors['required']">Address is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="user_name" class="form-label  mandatory">User Name</label>
                                        <input type="text" class="form-control" name="user_name" id="user_name"
                                            autocomplete="nope" [(ngModel)]="guestuser.user_name" #user_name="ngModel"
                                            required
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && user_name.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && user_name.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="user_name.errors['required']">User Name is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="password" class="form-label  mandatory">Password</label>
                                        <input type="password" class="form-control" name="password" id="password"
                                            autocomplete="nope" [(ngModel)]="guestuser.password" #password="ngModel"
                                            required minlength=8
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && password.invalid  }">
                                        <div *ngIf="companyDetailsForm.submitted && password.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="password.errors['required']">Password is required</div>
                                            <div *ngIf="password.errors['minlength']">Password is required to be at
                                                least 8
                                                characters</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="confirm_password" class="form-label  mandatory">Confirm
                                            Password</label>
                                        <input type="password" class="form-control" name="confirm_password"
                                            id="confirm_password" [(ngModel)]="guestuser.confirm_password"
                                            #confirm_password="ngModel" required minlength=8 autocomplete="nope"
                                            [ngClass]="{ 'is-invalid': companyDetailsForm.submitted && confirm_password.errors }">
                                        <div *ngIf="companyDetailsForm.submitted && confirm_password.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="confirm_password.errors['required']">Confirm Password is
                                                required</div>
                                            <div *ngIf="confirm_password.errors['minlength']">Password is required to be
                                                at
                                                least 8
                                                characters</div>
                                        </div>
                                        <div class="text-danger" style="font-size: 14px;"
                                            *ngIf="confirm_password.touched && (guestuser.password !== guestuser.confirm_password)">
                                            Passwords do not
                                            match</div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div class="d-flex justify-content-between mt-4">
                    <button routerLink="/login" class="btn btn-secondary">
                        <i class="fa-solid fa-arrow-left"></i>&nbsp;<span> Back</span>
                    </button>
                    <span *ngIf="!readable">
                        <button class="btn btn-primary" type="submit">
                            <i class="fa-solid fa-floppy-disk"></i>&nbsp;<span>Submit & Next</span>
                        </button>
                    </span>
                    <!-- <span *ngIf="readable">
                        <button class="btn btn-primary" (click)="navigateToNext()">
                            <i class="fa-solid fa-floppy-disk"></i>&nbsp;<span>Next</span>
                        </button>
                    </span> -->
                </div>
            </form>
        </div>
    </section>
</div>